import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const ClearLocalStorage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.clear();
    navigate(ROUTE_KEYS.LOGIN);
  }, []);
  return <div />;
};

export default ClearLocalStorage;
